var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"id":"core-footer","absolute":"","height":"82"}},[_c('v-spacer'),_c('span',{staticClass:"font-weight-light copyright"},[_vm._v(" © "+_vm._s((new Date()).getFullYear())+" "),_c('a',{attrs:{"href":"https://www.altitude-is.ch/","target":"_blank"}},[_vm._v("Altitude")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }